// Helper function to run a "forEach" style callback asynchronously on each element of an array
export function forEachAsync(array: any[], callback: (_element: any, _index?: number, _array?: any[]) => any) {
    const length = array.length;
    let i = 0;

    return new Promise((resolve, reject) => {
        const iterate = () => {
            setTimeout(() => {
                try {
                    callback(array[i], i, array);
                } catch(error) {
                    reject(error);
                }
                i += 1;
                if (i < length) {
                    iterate();
                } else {
                    resolve(true);
                }
            }, 0);
        }

        iterate();
    });
}

export async function sleep(ms=0) {
    return new Promise((resolve, reject) => {
        setTimeout(() => {
            return resolve(undefined);
        }, ms);
    });
}

/**
 * @description Try the async function up until opts.retries, with opts.waitBetweenMs delay between each,
 * until it returns a truthy value, otherwise it returns undefined.
 * @param {*} reqFn
 * @param {*} [opts] { retries: int, waitBeweenMs: int }
 * @return {*}
 */
 export const tryUntilSuccess = async (reqFn, opts?) => {

    return new Promise(async (resolve, reject) => {
        try {
            const tryFor = async (attempt=0) => {
                try {
                    console.log(`Try:`, attempt, opts);
                    if (attempt > opts.retries) return resolve(undefined);
                    const r = await reqFn();
                    if (r) return resolve(r);
                    setTimeout(async () => await tryFor(++attempt), opts.waitBetween);
                } catch (e) {
                    // let it retry
                    console.log(`Exception in tryUntilSuccess:`, e);
                    if (++attempt > opts.retries) return reject(e);
                    setTimeout(async () => await tryFor(attempt), opts.waitBetween);
                }
            }

            return await tryFor();
        } catch (e) {
            return reject(e);
        }
    });
};
